import React, { useEffect } from 'react';
import { NavLink } from 'react-router-dom';
import { connect } from 'react-redux';

import { fetchMainMenu } from '../../requests/menu_request';

export const Social = [
    {
        url: 'https://nl-nl.facebook.com/Friendsforbrands/',
        icon: 'icon-fb_icon',
    },
    {
        url: 'https://nl.linkedin.com/company/friends-for-brands',
        icon: 'icon-in_icon',
    },
    {
        url: 'https://www.instagram.com/friendsforbrands/',
        icon: 'icon-insta_icon',
    },
];

const MainMenu = (props) => {
    useEffect(() => {
        props.fetchMainMenu();
    }, []);

    const RenderSocial = () => (
        <div className="share">
            <div className="share-buttons">
                <ul>
                    {Social.map((item) => (
                        <li key={item.url}>
                            <a target="_blank" href={item.url}>
                                <i className={`icon ${item.icon}`} />
                            </a>
                        </li>
                    ))}
                </ul>
            </div>
        </div>
    );

    const renderMenu = (menu_items) => {
        return (
            menu_items.length > 0 &&
            menu_items.map((item) => {
                const menu_url = new URL(`${item.url}`);
                return (
                    <li key={item.object_id} className="nav-item">
                        <NavLink
                            to={menu_url.pathname}
                            activeClassName="active">
                            <span className="menu-title">{item.title}</span>
                            <span className="description">
                                {item.description}
                            </span>
                        </NavLink>
                    </li>
                );
            })
        );
    };

    return (
        <nav
            id="main-menu"
            className={props.showMenu ? 'menu-active' : 'menu-hidden'}>
            <div className="main-menu-wrapper">
                <ul className="menu">{renderMenu(props.menus)}</ul>
                <RenderSocial />
            </div>
        </nav>
    );
};

function mapStateToProps({ menus }) {
    return { menus };
}

export default connect(mapStateToProps, { fetchMainMenu })(MainMenu);



// WEBPACK FOOTER //
// ./src/components/Pages/MainMenu.jsx